import axios from 'axios';
import auth from '../auth';

function makeAxiosRequest({ url, method, data, includeToken }) {
    const headers = {
        'Content-Type': 'application/json',
    };

    if (includeToken) {
        headers.Authorization = `Bearer ${auth.getAccessToken()}`;
    }

    return axios({ url, method, data, headers });
}

export function makeAuthenticatedServiceRequest({ url, method = 'get', data }) {
    let promise = Promise.resolve();

    if (auth.isLoggedIn()) {
        promise = makeAxiosRequest({ url, method, data, includeToken: true });
    }

    return promise;
}

export function makePublicServiceRequest({ url, method = 'get', data }) {
    return makeAxiosRequest({ url, method, data });
}



// WEBPACK FOOTER //
// ./src/services/servicesClient.js